import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isOpenNow } from '../lib/mapConfig';

export function BusinessCard({ business }) {
  const navigate = useNavigate();

  const categoryLabels = {
    mercado: 'Mercado', farmacia: 'Farmácia', padaria: 'Padaria',
    restaurante: 'Restaurante', servicos: 'Serviços', evento: 'Evento', publico: 'Público'
  };

  const categoryEmojis = {
    mercado: '🛒', farmacia: '💊', padaria: '🥖', restaurante: '🍽️',
    servicos: '🔧', evento: '🎉', publico: '🏛️'
  };

  // LE-039: card focado em ofertas (inspirado no whir) — badge "Hoje" para
  // comércio com promoção/impulso ativo e horário do dia atual, sempre que a
  // listagem trouxer os horários (business_hours).
  const hasDeal = Boolean(business.hasPromotion || business.isBoosted || (business.promotions && business.promotions.length > 0));
  const open = isOpenNow(business.hours);

  const todayHours = (() => {
    if (!Array.isArray(business.hours) || business.hours.length === 0) return null;
    const now = new Date();
    const today = business.hours.find((h) => Number(h.day_of_week) === now.getDay());
    if (!today) return null;
    if (today.is_24h) return 'Aberto 24h';
    if (today.is_closed) return 'Fechado hoje';
    const fmt = (t) => (t ? String(t).slice(0, 5) : '');
    const openT = fmt(today.open_time);
    const closeT = fmt(today.close_time);
    if (!openT || !closeT) return null;
    return `${openT} – ${closeT}`;
  })();

  return (
    <div
      className="nc-business-card"
      onClick={() => navigate(`/comercio/${business.id}`)}
    >
      <div className="nc-business-card__logo">
        {business.logo_url ? (
          <img src={business.logo_url} alt={`Logo de ${business.name}`} />
        ) : (categoryEmojis[business.category] || '🏪')}
      </div>
      <div className="nc-business-card__body">
        <div className="nc-business-card__title-row">
          <span className="nc-business-card__name">{business.name}</span>
          {hasDeal && (
            <span className="nc-business-card__today">Hoje</span>
          )}
          {(business.hasPromotion || business.promotions?.length > 0) && (
            <span className="nc-business-card__badge">PROMO</span>
          )}
        </div>
        <div className="nc-business-card__meta">
          {categoryLabels[business.category] || business.category} • {business.address}
        </div>
        {todayHours && (
          <div className={`nc-business-card__hours${open == null ? '' : open ? ' nc-business-card__hours--open' : ' nc-business-card__hours--closed'}`}>
            <span aria-hidden="true">{open == null ? '🕐' : open ? '🟢' : '⚪'}</span>
            {open == null ? todayHours : open ? `${todayHours} — aberto agora` : `${todayHours} — fechado`}
          </div>
        )}
        <div className="nc-business-card__rating-row">
          <span className="nc-business-card__stars">
            {'★'.repeat(Math.floor(business.rating))}{'☆'.repeat(5 - Math.floor(business.rating))}
          </span>
          <span className="nc-business-card__reviews">({business.reviewCount ?? business.reviews ?? 0})</span>
          {business.distance != null && (
            <span className="nc-business-card__distance">{business.distance}m</span>
          )}
        </div>
      </div>
    </div>
  );
}
